module.exports = __webpack_public_path__ + "static/mental-model-fcff9af8e47bd635930fa98a9a9bf978.png";